import { render } from "./x.vue?vue&type=template&id=29236e9f&scoped=true"
import script from "./x.vue?vue&type=script&lang=ts"
export * from "./x.vue?vue&type=script&lang=ts"

import "./x.vue?vue&type=style&index=0&id=29236e9f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29236e9f"

export default script